import React from 'react';

const AboutPortfolio = () => {
  const platforms = [
    { name: 'LinkedIn', image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/240px-LinkedIn_logo_initials.png', profileLink: 'https://www.linkedin.com/in/ram-mohan-dixit-817a6a224/' },
    { name: 'GeekForGeeks', image: 'https://media.geeksforgeeks.org/wp-content/cdn-uploads/20190710102234/download3.png', profileLink: 'https://auth.geeksforgeeks.org/user/ramodixit577' },
    { name: 'CodeChef', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScsV-DoHaWN1duldWWuIp08UAzHF10Obv6Bxd1ruyMWw&s', profileLink: 'https://www.codechef.com/users/ramo_codex23' },
    { name: 'LeetCode', image: 'https://upload.wikimedia.org/wikipedia/commons/1/19/LeetCode_logo_black.png', profileLink: 'https://leetcode.com/codex_156/' },
    { name: 'Youtube', image: 'https://images.indianexpress.com/2023/05/youtube-logo-featured.jpg?w=414', profileLink: 'https://www.youtube.com/@codeformode' },
    { name: 'Instagram', image: 'https://cdn.pixabay.com/photo/2021/10/24/21/23/instagram-6739334_640.jpg', profileLink: 'https://www.instagram.com/c_language_programming/' }
  ];

  return (
    <div className="bg-red-400">
      <div className="container mx-auto">
        <h1 className="text-center text-3xl font-bold mb-8 p-2">About Portfolio</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-4">
          {platforms.map((platform, index) => (
            <div key={index} className="bg-gray-400 p-4 rounded-md text-center">
              <img src={platform.image} alt={platform.name} className="mx-auto w-32 h-32 object-contain" />
              <h2 className="text-xl font-bold mt-4">{platform.name}</h2>
              <a href={platform.profileLink} target="_blank" rel="noopener noreferrer">
                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-2 rounded">View Profile</button>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutPortfolio;
